import "./style.scss"

export const WorkPage = ({data,path=''}) => {
    return (
        <div className={`workpage_block ${path==='welding' ? 'big_workpage' : ''}`}>
            {data}
        </div>
    )
}